export function MappingAddress(_dataMap) {
  let address = {
    address1: '',
    address2: '',
    address3: '',
    state: '',
    city: '',
    zip: '',
    country: '',
    countryCode: ''
  };

  if (!_dataMap) {
    return address;
  }

  _dataMap.forEach((item) => {
    if (item.types.length > 0) {
      switch (item.types[0]) {
        case 'subpremise':
          address = {
            ...address,
            address1: item.long_name + (address.address1 !== '' ? ' / ' + address.address1 : '')
          };
          break;
        case 'street_number':
          address = {
            ...address,
            address1: (address.address1 !== '' ? address.address1 + ' / ' : '') + item.long_name
          };
          break;
        case 'route':
          address = {
            ...address,
            address2: item.long_name
          };
          break;
        case 'locality':
          address = {
            ...address,
            city: item.long_name
          };
          break;
        case 'administrative_area_level_1':
          address = {
            ...address,
            state: item.short_name
          };
          break;
        case 'country':
          address = {
            ...address,
            countryCode: item.short_name,
            country: item.long_name
          };
          break;
        case 'postal_code':
          address = {
            ...address,
            zip: item.long_name
          };
          break;
        default:
          break;
      }
    }
  });

  return address;
}
